import { DropdownOption, DropdownOptionType } from './types';
import { noop } from 'lodash';
import { defaultPosition } from '../dropdownConsts';
import fscreen from 'fscreen';

export const enhanceOptionsWithDefaults = (
  options: Partial<DropdownOption>[] = []
): DropdownOption[] =>
  options.map(option => ({
    ...option,
    onClick: option.onClick || noop,
    name: option.name || '',
    label: option.label || '',
    type: option.type || DropdownOptionType.OPTION,
  }));

export const getEventTargetRect = (event: React.MouseEvent) => {
  if (!(event.target instanceof Element)) {
    return defaultPosition;
  }
  return event.target.getBoundingClientRect();
};

export const simpleNotifier = () => {
  const subscriptions: VoidFunction[] = [];

  return {
    subscribe: (handler: VoidFunction) => {
      subscriptions.push(handler);
    },
    unsubscribe: (handler: VoidFunction) => {
      const index = subscriptions.indexOf(handler);
      if (index === -1) {
        return;
      }
      subscriptions.splice(index, 1);
    },
    notify: () => {
      subscriptions.forEach(subscription => subscription());
    },
  };
};

export const getDropdownMenuPortalTarget = () =>
  fscreen.fullscreenElement instanceof HTMLElement
    ? fscreen.fullscreenElement
    : document.body;
